import logo from "./logo.svg";
// import "./App.css";
// import "./../public/css/style.css";
// import "./../public/css/styleCustom.css";

import { Fragment, useContext } from "react";

import LayoutAuthorized from "./Components/layout/LayoutAuthorized";
import LayoutUnAuthorized from "./Components/layout/LayoutUnAuthorized";
import RoutingAuthorized from "./Components/Routings/RoutingAuthorized";
import AuthContext from "./store/auth-context";
// React Notification
import "react-notifications/lib/notifications.css";
import { NotificationContainer } from "react-notifications";
import RoutingUnAuthorized from "./Components/Routings/RoutingUnAuthorized";

function App() {
  // let isLoggedIn = true;
  // const { user, login, logout } = useContext(UserContext);
  const { token, isLoggedIn, login, logout, loginHandler, logoutHandler } =
    useContext(AuthContext);

  return (
    <Fragment>
      {isLoggedIn && (
        <LayoutAuthorized>
          <RoutingAuthorized />
        </LayoutAuthorized>
      )}
      {!isLoggedIn && (
        <LayoutUnAuthorized>
          <RoutingUnAuthorized />
        </LayoutUnAuthorized>
      )}
      <NotificationContainer />
    </Fragment>
  );
}

export default App;
